
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';

Vue.use(Toast).use(Popup);
@Component
export default class AliPayButton extends Vue {
  @Prop({ required: true }) submitType!: string;
  @Prop({ required: true }) subject!: string; // 支付的标题
  @Prop({ required: true }) payType!: number; // 支付的类型 1:支付宝； 2: 微信
  @Prop({ required: true }) userId!: number; // 用户id
  @Prop({ required: true }) amount!: number; // 支付金额
  @Prop({ required: true }) actId!: number; // 活动id
  @Prop({ required: true }) username!: string; // 手机号
  @Prop({ default: true }) canPay!: boolean;
  @Prop({}) maxTopup!: number; // 最大金额限制
  pointOut: boolean = false;

  // 充值的地址
  get baseUrl(): string {
    const ENV = process.env.VUE_APP_ENV_NAME;
    // return `//devvoteone.cqcb.com/vote/public/pay/pay.php`;
    switch (ENV) {
      case 'DEV':
        return `//devvoteone.cqcb.com/vote/public/pay/pay.php`;
      case 'TEST':
        return `//testvoteone.cqcb.com/vote/public/pay/pay.php`;
      case 'production':
        return `//voteone.cqcb.com/vote/public/pay/pay.php`;
      default:
        return `//voteone.cqcb.com/vote/public/pay/pay.php`;
    }
  }

  async initUserInfo() {
    // 获取用户信息
    if (!this.userId) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return false;
    }
    return true;
  }
  // 开始充值
  handlePay() {
    // 判断是否有userId
    if (!this.initUserInfo()) {
      return;
    }
    // 判断充值金额是否有误
    // if (!this.judgeAmount()) {
    //   return;
    // }
    // 微信版本支付版本不能低于4.8.8

    // const versionNum = Number(window.version.split('.').join(''));
    // if (this.payType === 2 && versionNum < 488) {
    //   Toast('请安装上游新闻最新版本后使用微信支付');
    //   return;
    // }

    // 判断最大充值金额限制
    if (this.maxTopup && this.amount > this.maxTopup) {
      Toast(`单次充值金额不能超过${this.maxTopup}`);
      return;
    }
    if (!this.canPay) {
      Toast.fail('现在不能充值！');
      return;
    }
    // console.log('start topup....');
    // const id = `aliyun_form${this.submitType}`;
    // console.log('start topup....', id);
    (this.$refs.aliyun_form as HTMLFormElement).submit();
  }
  // 判断金额
  judgeAmount(): boolean {
    const temp = this.amount.toString();
    if (temp.indexOf('.') > -1) {
      Toast.fail('充值金额不能含有小数点');
      return false;
    } else if (temp.indexOf('e') > -1) {
      Toast.fail('请输入正整数');
      return false;
    } else if (temp.indexOf('-') > -1) {
      Toast.fail('请输入正整数');
      return false;
    } else if (Number(temp) === 0) {
      Toast.fail('请输入正确的充值金额');
      return false;
    }

    return true;
  }
}
